import { NgModule     }         from '@angular/core';
import { CommonModule }         from '@angular/common';
import { FormsModule  }         from '@angular/forms';
import { IonicModule  }         from 'ionic-angular';
import { RouterModule, Routes } from '@angular/router';

import {loginComponent}                 from './pages/login/login.page';
import {logoutComponent}                from './pages/logout/logout.page';
import {profileComponent, profileHeaderComponent}               from './pages/profile/profile.page';
import {loginPage}                      from './pages/route/login.route';
import {loginStarterComponent }         from './pages/startup/startup.page';

import {FaceBookService}        from './providers/facebook-provider'
import {FirebaseService}        from './providers/firebase-provider'
import {UserService}            from './providers/userService-provider'

const dashboardRoutes: Routes = [
    { path: 'login', component: loginPage },
    { path: '', component: loginPage }
];



@NgModule({
    imports:
        [
            IonicModule.forRoot(loginPage),
            CommonModule,
            RouterModule.forChild(dashboardRoutes)
        ],
    declarations:
        [
            loginComponent,         logoutComponent,    profileComponent,
            profileHeaderComponent, loginPage,          loginStarterComponent
        ],
    providers:
        [
            FaceBookService,
            FirebaseService,
            UserService
        ],
    exports:
        [
            loginComponent, logoutComponent,
            profileComponent,
            profileHeaderComponent,
            loginPage, loginStarterComponent,
            CommonModule, FormsModule
        ]
})
export class userModule { }


//TODO: -
//    1. facebooksdk should added externally to index file
//    2. Depends upon angularfire2


// WEBPACK FOOTER //
// ./src/app/feature/loginModule/user.module.ts